<template>
  <v-list-item class="pa-0">
    <v-list-item v-if="modelValue.length === itens.length" class="py-2 pl-person" :class="contentClass" @click="atualizarValorDeModel([])">
      <v-icon class="pl-2" color="primary">mdi-checkbox-marked</v-icon>
      <span class="ml-2 font-weight-medium">Desmarcar Todos</span>
    </v-list-item>

    <v-list-item v-else class="py-2 pl-person" :class="contentClass" @click="setSelecionaTudo">
      <v-icon v-if="modelValue.length > 0" class="pl-2" color="primary">mdi-minus-box</v-icon>
      <v-icon v-else class="pl-2">mdi-checkbox-blank-outline</v-icon>

      <span class="ml-2 font-weight-medium">Selecionar Todos</span>
    </v-list-item>
  </v-list-item>
</template>

<script>
export default {
  name: "SysItemListaSelecionaTudo",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    itens: {
      type: Array,
      required: true
    },
    modelValue: {
      type: Array,
      required: true
    },
    valorChave: {
      type: [String, Array],
      default: null
    },
    selectFullOnChange: {
      type: Boolean,
      default: false
    },
    contentClass: String
  },
  watch: {
    itens() {
      if (this.selectFullOnChange) {
        this.setSelecionaTudo()
      }
    }
  },
  methods: {
    setSelecionaTudo () {
      const novosSelecionados = this.valorChave ? this.Helpers.arrayColumn(this.itens, this.valorChave) : this.itens
      this.atualizarValorDeModel(novosSelecionados)
    },
    atualizarValorDeModel (itens) {
      this.$emit("update:modelValue", itens)
    }
  }
}
</script>

<style scoped>
.pl-person {
  padding-left: 14px;
}
</style>
